// function for setting cell color based on percentage //
import React from 'react'
import tinycolor from 'tinycolor2'

import perfStyles from '../components/model_perf.module.scss'

const DisplayPerfPct = ( { pct, market_pct, scale } ) => {

    const neg_color = '#ffabc0'
    const neg_text = '#c22d52'
    const zero_color = '#ffffff'
    const pos_color = '#96ffdd'
    const pos_text = '#26b588'

    const delta = pct - market_pct
    var styling = {}

    if (delta < 0) {
        styling = {
            backgroundColor : tinycolor.mix(zero_color, neg_color, Math.abs(delta) * scale),
            color : neg_text
        }
    } else if (delta === 0) {
        styling = {
            backgroundColor : 'white',
            color : 'black'
        }
    } else {
        styling = {
            backgroundColor : tinycolor.mix(zero_color, pos_color, Math.abs(delta) * scale),
            color : pos_text
        }
    }
    

    return(
        <div className={perfStyles.pctDiv} style={styling}>
            <p className={perfStyles.pctP}>
                {(100*pct).toFixed(1)}%
            </p>
        </div>

    )
}

export default DisplayPerfPct